import { CommonConfig } from 'types/config';

// eslint-disable-next-line import/prefer-default-export
export const defaultState: CommonConfig = {
  payouts: {
    isPayoutFrozen: false,
    canExportPayouts: false,
    payoutFrozenFrom: '',
    payoutFrozenTo: '',
  },
  categories: [],
  countries: [],
  env: '',
  features: {},
  url: null,
  creativeDomains: [],
  tags: [],
  otherCountryCode: '',
  trafficOrientations: {},
  trafficTypes: {},
  debug: false,
  isAffiliate: false,
  referrer: '',
  serverTime: '',
  language: null,
  acl: {},
};
